import { render, staticRenderFns } from "./OfferItem.vue?vue&type=template&id=49593d5e&scoped=true&"
import script from "./OfferItem.vue?vue&type=script&lang=js&"
export * from "./OfferItem.vue?vue&type=script&lang=js&"
import style0 from "./OfferItem.vue?vue&type=style&index=0&id=49593d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49593d5e",
  null
  
)

export default component.exports